/**
 * Surfaces GraphQL validation / resolver messages instead of only "status code 400".
 */
export function formatApolloErrorMessage(error: unknown): string {
  if (!error || typeof error !== 'object') {
    return 'Failed to run Mailgun test.';
  }

  const anyErr = error as {
    message?: string;
    graphQLErrors?: ReadonlyArray<{ message?: string }>;
    networkError?: {
      message?: string;
      statusCode?: number;
      result?: { errors?: ReadonlyArray<{ message?: string }> };
    };
  };

  const gqlMsgs = anyErr.graphQLErrors?.map((e) => e.message).filter(Boolean);
  if (gqlMsgs?.length) {
    return gqlMsgs.join('; ');
  }

  const net = anyErr.networkError;
  const bodyErrors = net?.result?.errors?.map((e) => e.message).filter(Boolean);
  if (bodyErrors?.length) {
    return bodyErrors.join('; ');
  }

  if (net?.message) {
    return net.message;
  }

  if (typeof anyErr.message === 'string' && anyErr.message) {
    return anyErr.message;
  }

  return 'Failed to run Mailgun test.';
}
